import * as angular from 'angular';

import { GaugeWidgetBase } from './gaugeBase.widget';
import { IInputValuesService } from '../../services';
import { IRootScope } from '../../IRootScope';
import { IWidgetConfiguration } from '../';
import { WideError, widgetDataInitialized } from '../../common/';
import { ErrorLevel } from '../../models/';
import { GaugeColors } from './GaugeColor';
import { IGaugeWidget } from './IgaugeWidget';

export class PercentageOfGoodValuesWidget extends GaugeWidgetBase implements IGaugeWidget {
    name = 'Percentage of good values';
    type = 'percentageOfGoodValuesGauge';
    highlights = ['A gauge showing the overall percentage of good values'];

    private _inputValuesService: IInputValuesService;

    constructor(private _$rootScope: IRootScope,
        $q: angular.IQService,
        inputValuesService: IInputValuesService,
        config?: IWidgetConfiguration) {

        super($q, config);

        this._inputValuesService = inputValuesService;

        this.options = {
            title: this.name,
            bands: [
                { min: 0, max: 0.7, classed: 'fill-error', level: ErrorLevel.Error, message: 'Percentage of good values is too low', color: GaugeColors.red },
                { min: 0.7, max: 0.95, classed: 'fill-warn', level: ErrorLevel.Warning, message: 'Percentage of good values is a bit too low', color: GaugeColors.orange },
                { min: 0.95, max: 1, classed: 'fill-success', level: ErrorLevel.Success, message: 'Percentage of good values is Ok', color: GaugeColors.green }
            ],
            isTitleVisible: false
        };

        this.readData();
    }

    getErrorBetweenDates(beginDate: string, endDate: string): angular.IPromise<WideError> {
        const promise = this._inputValuesService.getPercentageOfGoodValuesBetweenDates(beginDate, endDate);
        return super.computeErrorAsync(promise);
    }

    readData(guid?: string): angular.IPromise<number> {
        const promise = this.isTagMode
            ? this._inputValuesService.getPercentageOfGoodValuesForTag(this.tagDefinitionGuid)
            : this._inputValuesService.getPercentageOfGoodValues(guid);

        return promise
            .then((value) => {
                super.value(value);
                this._$rootScope.$broadcast(widgetDataInitialized);
                return value;
            });
    }
}